import { OverrideReportingActionTypes, OverrideReportingActions } from './override-reporting.actions';
import { IOverrideReporting } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IOverrideReporting | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: OverrideReportingActions): State {
    switch (action.type) {

        case OverrideReportingActionTypes.LoadOverrideReportingState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case OverrideReportingActionTypes.LoadOverrideReportingStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case OverrideReportingActionTypes.LoadOverrideReportingStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case OverrideReportingActionTypes.OverrideReportingScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;